import { PayloadAction } from "@reduxjs/toolkit";
import { AllState } from "../models/AllState";
import { LoadingDataPayload } from "../payload/LoadingDataPayload";

const setLoadingData = (state: AllState, action: PayloadAction<LoadingDataPayload>) => {
    state.isLoadingData = action.payload.status;
}

export default setLoadingData;